import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d746dace&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ApiLogo: require('/home/runner/work/api-docs-frontend/api-docs-frontend/components/global/Logo/ApiLogo.vue').default,SearchTrigger: require('/home/runner/work/api-docs-frontend/api-docs-frontend/components/global/SearchTrigger/index.vue').default,Menu: require('/home/runner/work/api-docs-frontend/api-docs-frontend/components/Menu/index.vue').default})
